import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
function TooltipHeadingText(props) {
  const {
    toolAccess
  } = props;
  if (toolAccess.loading) {
    return null;
  }
  if (toolAccess.error || !toolAccess.toolName) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.defaultTitle"
    });
  }
  if (toolAccess.request) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "toolAccess.requestPending"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "toolAccess.tooltip.noAccessTitle",
    options: {
      toolName: toolAccess.toolName
    }
  });
}
export default TooltipHeadingText;